import { IconButton } from '@healthhub/react-ui';
import type { ReactNode } from 'react';

import { OutlinedCloseIcon } from '@shared/assets-icon';

interface AccountSettingsDropdownPopupProps {
  header: string;
  menu: ReactNode;
  toggleDropdown: () => void;
}

const AccountSettingsDropdownPopup = ({ header, menu, toggleDropdown }: AccountSettingsDropdownPopupProps) => (
  <div className="bg-white rounded-lg shadow-[0px_4px_12px_0px_rgba(0,0,0,0.12)] w-[16.75rem] md:w-[15rem]">
    <div className="py-2 flex w-full">
      <div className="flex justify-between px-4 py-1 w-full items-center">
        <p className="p2 text-primary-blue-grey-4 font-semibold">{header}</p>
        <IconButton
          aria-label="Close"
          className="h-full w-4 flex ml-auto"
          icon={<OutlinedCloseIcon className="size-4 self-center [&_path]:fill-primary-blue-grey-3" />}
          onClick={toggleDropdown}
        />
      </div>
    </div>

    <div className="[&_>_ul]:rounded-t-none [&_>_ul]:rounded-b-lg [&_>_ul]:shadow-none [&_>_ul]:px-0 [&_>_ul]:pt-0 [&_>_ul]:pb-4 [&_li]:px-4 [&_li]:py-2 [&_.ant-dropdown-menu-title-content]:text-sm [&_.ant-dropdown-menu-title-content]:text-functional-black [&_li:hover]:bg-secondary-green-100">
      {menu}
    </div>
  </div>
);

export default AccountSettingsDropdownPopup;
